import React from "react";
import Typography from "@material-ui/core/Typography";

export const BasicTooltipText = ({ children }) => (
    <Typography variant="body2" style={{ color: "#4a4a4a" }}>
        {children}
    </Typography>
);
